@if (valid) {
  <img
    class="medium-check-circle relative"
    src="assets/images/svgs/check-circle--green.svg"
  />
} @else {
  <span>&bullet;</span>
}
